---
title: On materials as language
date: 2026-05-12
author: Brian Ellison
category: Craft
excerpt: A short note on why we keep coming back to limewash, bronze, and quarter-sawn oak — and why the answer is grammatical, not aesthetic.
placeholder: true
---

People often ask why so many BED projects use the same handful of materials. The answer isn't that we have favorites — it's that materials behave like **vocabulary**, and a small vocabulary is easier to compose into sentences that mean something.

Limewash plaster reads as a kind of **honest paint** — it admits its trowel marks, it accepts daylight unevenly. Bronze that has been allowed to weather rather than polished reads as **patient metal** — it has age, even when it's new. Quarter-sawn oak reads as **disciplined wood** — straight grain, no drama.

Put those three in a room and you have a complete sentence about restraint, time, and material truthfulness. Add a fourth — say, an oxblood mohair — and you have a paragraph.

The opposite mistake is to use twelve materials in a room and end up saying nothing. A wider vocabulary just lets you mumble.

So we work in small palettes. Not because we're minimalists — we're not — but because we want the room to be **legible**.
